export default __webpack_public_path__ + "static/media/stp.30573625.svg";